<template>
  <div class="container">
    <li class="return">
      <span @click="$router.go(-1)"
        ><i class="el-icon-arrow-left"></i>返回</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>订单列表</span>
    </li>
    <li class="orderName">订单名称：{{ orderName }}</li>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column align="center" prop="code" label="订单编号">
      </el-table-column>
      <el-table-column align="center" label="交易时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.create_time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column label="融资金额" align="center">
        <template #default="scope"> {{ scope.row.amount }}万元 </template>
      </el-table-column>
      <el-table-column
        prop="investment_name"
        align="center"
        label="资方名称"
      ></el-table-column>
      <el-table-column
        prop="financing_name"
        align="center"
        label="项目方名称"
      ></el-table-column>
      <el-table-column label="订单类型" align="center">
        <template #default="">线上 </template>
      </el-table-column>
      <el-table-column label="进度" align="center">
        <template #default="scope">
          <el-link
            :underline="false"
            href="javascript:void(0);"
            type="danger"
            v-if="scope.row.status === 11"
            >投资结束</el-link
          >
          <el-link
            :underline="false"
            href="javascript:void(0);"
            type="success"
            v-if="scope.row.status === 9"
            >投资中</el-link
          >
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="180" align="center">
        <template #default="scope"> </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      orderName: "",
    };
  },
  methods: {
    async getData(page = 1) {
      const params = {
        targetId: this.$route.params.id,
        targetType: this.$route.query.type,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.investment.list.getOrderList(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.orderName = res.data.records[0].project_name;
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.return {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid $--border-color-base;

  span {
    cursor: pointer;
    font-size: 0.875rem;
    color: $--color-text-regular;
  }
}

.orderName {
  font-size: 0.875rem;
  margin-bottom: 24px;
  color: $--color-text-regular;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  h2 {
    font-size: 1rem;
    font-weight: 500;
    padding: 5px 0;
    color: $--color-primary;
  }

  .atlas {
    display: flex;

    & > div {
      width: 160px;
      height: 90px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  table {
    margin: 10px 0;
    td {
      width: 120px;
      height: 36px;
      font-size: 0.875rem;
      text-align: center;
      vertical-align: middle;
      color: $--color-text-regular;
      border: 1px solid $--border-color-base;
    }
  }

  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      padding: 0;
    }
  }

  .remark {
    .title {
      margin: 24px 0;
      padding-left: 10px;
      font-size: 1.125rem;
      border-left: 2px solid #409eff;
    }

    .remark-content {
      font-size: 0.875rem;
      p {
        line-height: 26px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
</style>